import { Avatar, Box, Card, CardContent, Stack, Typography } from '@mui/material';
import BuildCircleOutlinedIcon from '@mui/icons-material/BuildCircleOutlined';
import AdminToolsHealthCard from './AdminToolsHealthCard';

const borderColor = 'rgba(245, 158, 11, 0.35)';

const AdminToolsPage = () => (
  <Stack spacing={2.5}>
    <Card sx={{ border: '1px solid', borderColor, borderRadius: 3, boxShadow: 'none' }}>
      <CardContent sx={{ py: 2 }}>
        <Stack direction="row" spacing={1.2} alignItems="center">
          <Avatar sx={{ bgcolor: 'rgba(245,158,11,0.15)', color: '#f59e0b', width: 42, height: 42 }}>
            <BuildCircleOutlinedIcon />
          </Avatar>
          <Box>
            <Typography variant="h5" sx={{ fontWeight: 700 }}>
              Tools Runtime
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Validate engine availability, dependencies, and worker readiness.
            </Typography>
          </Box>
        </Stack>
      </CardContent>
    </Card>
    <AdminToolsHealthCard />
  </Stack>
);

export default AdminToolsPage;
